import { ChevronLeft, ChevronRight } from "lucide-react";

export default function Pagination({ page, pages, total, limit, onPageChange }) {
  if (!pages || pages <= 1) {
    return (
      <div className="flex items-center justify-between px-1 py-3 text-body-sm text-on-surface-variant">
        <span>{total ?? 0} result{total === 1 ? "" : "s"}</span>
      </div>
    );
  }

  const start = (page - 1) * limit + 1;
  const end = Math.min(page * limit, total);

  const pageNumbers = [];
  const windowSize = 1;
  for (let p = 1; p <= pages; p++) {
    if (p === 1 || p === pages || Math.abs(p - page) <= windowSize) {
      pageNumbers.push(p);
    } else if (pageNumbers[pageNumbers.length - 1] !== "…") {
      pageNumbers.push("…");
    }
  }

  return (
    <div className="flex flex-col items-center justify-between gap-3 px-1 py-3 sm:flex-row">
      <span className="text-body-sm text-on-surface-variant">
        Showing {start} to {end} of {total} results
      </span>
      <div className="flex items-center gap-1">
        <button
          disabled={page <= 1}
          onClick={() => onPageChange(page - 1)}
          className="flex h-8 w-8 items-center justify-center rounded-md border border-outline-variant text-on-surface-variant hover:bg-surface-container-low disabled:opacity-40"
        >
          <ChevronLeft size={16} />
        </button>
        {pageNumbers.map((p, i) =>
          p === "…" ? (
            <span key={`e${i}`} className="px-1.5 text-on-surface-variant">
              …
            </span>
          ) : (
            <button
              key={p}
              onClick={() => onPageChange(p)}
              className={`flex h-8 w-8 items-center justify-center rounded-md text-body-sm font-medium transition-colors ${
                p === page
                  ? "bg-primary text-primary-on"
                  : "text-on-surface-variant hover:bg-surface-container-low"
              }`}
            >
              {p}
            </button>
          )
        )}
        <button
          disabled={page >= pages}
          onClick={() => onPageChange(page + 1)}
          className="flex h-8 w-8 items-center justify-center rounded-md border border-outline-variant text-on-surface-variant hover:bg-surface-container-low disabled:opacity-40"
        >
          <ChevronRight size={16} />
        </button>
      </div>
    </div>
  );
}
